import { Link } from 'react-router-dom'
import type { Client } from '../types'
import { TableRow, TableCell } from '@/components/ui/table'

function timeAgo(iso: string): string {
  const diff = Date.now() - new Date(iso).getTime()
  const mins = Math.floor(diff / 60000)
  if (mins < 60) return `${mins}m ago`
  const hours = Math.floor(mins / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 30) return `${days}d ago`
  const months = days / 30.44
  if (months < 12) return `${months.toFixed(1)}mo ago`
  const years = months / 12
  return `${years.toFixed(1)}y ago`
}

interface ClientCardProps {
  client: Client
  shareCount: number
  lastActive?: string | null
}

export function ClientCard({ client, shareCount, lastActive }: ClientCardProps) {
  return (
    <TableRow className="cursor-pointer hover:bg-muted/50">
      <TableCell className="whitespace-nowrap">
        <Link to={`/users/${encodeURIComponent(client.email)}`} className="text-foreground hover:text-seed-green-600">
          {client.email}
        </Link>
      </TableCell>
      <TableCell className="whitespace-nowrap text-muted-foreground">{client.name}</TableCell>
      <TableCell className="whitespace-nowrap">
        {shareCount > 0 ? (
          <span className="text-seed-green-600">{shareCount} active</span>
        ) : (
          <span className="text-muted-foreground">0</span>
        )}
      </TableCell>
      <TableCell className="whitespace-nowrap text-muted-foreground">
        {lastActive ? timeAgo(lastActive) : '—'}
      </TableCell>
    </TableRow>
  )
}
